import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Button } from '~/components/Button/Button';
import { Fragment } from 'react/jsx-runtime';
import { Link } from 'react-router';

export function Page() {
  return (
    <Fragment>
      <Fragment>
        <PageLayout.Heading text="Verifiering lyckades!" />
        <p style={{ marginBottom: 'var(--size-4)' }}>
          Din e-postadress har nu bekräftats, och ditt konto är aktiverat. Du kan nu logga in och börja använda
          tjänsten.
        </p>
        <Link to="/auth/sign-in">
          <Button type="button">Logga in</Button>
        </Link>
      </Fragment>
    </Fragment>
  );
}
